module.exports = __webpack_public_path__ + "img/digitalsocialhour-white-text-only-powered.ef3737c2.png";